import {FetchOptions, PotionBase} from './potion';
import {Item} from './item';
/**
 * Array like class with resources.
 * The class is returned when the {paginate} option is set to `true` when a query is made.
 * 
 * \@example 
 * class User extends Item {}
 * 
 * User.query(null, {paginate: true}).then((users) => {
 *     for (let user of users) {
 *         console.log(user);
 *     }
 * });
 */
export class Pagination<T extends Item> implements Iterable<T> {
/**
 * @return {?}
 */
static get [Symbol.species]() {
        return Pagination;
    }
/**
 * @return {?}
 */
get page(): number {
        return this.$page;
    }
/**
 * @param {?} page
 * @return {?}
 */
set page(page: number) {
        this.changePageTo(page);
    }
/**
 * @return {?}
 */
get perPage(): number {
        return this.$perPage;
    }
/**
 * @return {?}
 */
get pages(): number {
        return Math.ceil(this.$total / this.$perPage);
    }
/**
 * @return {?}
 */
get total(): number {
        return this.$total;
    }
/**
 * @return {?}
 */
get length(): number {
        return this.items.length;
    }
private potion: PotionBase;
private uri: string;
private $page: number;
private $perPage: number;
private $total: number;
/**
 * @param {?} __0
 * @param {?} items
 * @param {?} count
 * @param {?} options
 */
constructor({potion, uri}: {potion: PotionBase, uri: string},
private items: T[], count: string,
private options: FetchOptions) {
        this.potion = potion;
        this.uri = uri;

        // tslint:disable-next-line: no-magic-numbers
        const {page = 1, perPage = 25}: any = {...this.options.params};
        this.$page = page;
        this.$perPage = perPage;
        this.$total = parseInt(count, 10);
    }
/**
 * @return {?}
 */
[Symbol.iterator](): IterableIterator<T> {
        return this.items.values();
    }
/**
 * @return {?}
 */
toArray(): T[] {
        return this.items.slice(0);
    }
/**
 * @param {?} index
 * @return {?}
 */
at(index: number): T {
        return this.items[index];
    }
/**
 * @param {?} page
 * @return {?}
 */
changePageTo(page: number): Promise<T | T[] | Pagination<T> | any> {
        const {pagination} = this.options;
        ( /** @type {?} */((this.options.params as any))).page = page;
        this.$page = page;
        return this.potion.fetch(this.uri, this.options, {
            pagination
        });
    }
/**
 * @param {?} items
 * @param {?} count
 * @return {?}
 */
update(items: T[], count: number): this {
        this.items.splice(0, this.items.length, ...items);

        this.$total = count;
        return this;
    }
}

function Pagination_tsickle_Closure_declarations() {
/** @type {?} */
Pagination.prototype.potion;
/** @type {?} */
Pagination.prototype.uri;
/** @type {?} */
Pagination.prototype.$page;
/** @type {?} */
Pagination.prototype.$perPage;
/** @type {?} */
Pagination.prototype.$total;
/** @type {?} */
Pagination.prototype.items;
/** @type {?} */
Pagination.prototype.options;
}

